
import { useEffect, useState } from 'react';
import * as React from 'react';
import { PopupWidget } from 'react-calendly';

export function CalendlyWidget() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!mounted) {
      setMounted(true);
    }
  }, []);

  if (!mounted) return null;

  return (
    <PopupWidget
      text="Get a demo!"
      textColor="#1CEFA5"
      color="#171a25"
      url="https://calendly.com/flagsync/15min"
      rootElement={document.getElementById('root')!}
    />
  );
}
